import { FC } from "react";
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  ModalProps,
} from "@chakra-ui/react";

import RoomPasswordForm from "./RoomPasswordForm";
import { useTranslation } from "react-i18next";

type IRoomPasswordModalProps = Omit<ModalProps, "children" | "onClose"> &
  Partial<Pick<ModalProps, "onClose">>;

const RoomPasswordModal: FC<IRoomPasswordModalProps> = ({
  onClose,
  ...rest
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      scrollBehavior="outside"
      onClose={onClose ? onClose : () => {}}
      {...rest}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t("room.passwordForm.title")}</ModalHeader>
        {onClose && <ModalCloseButton />}

        <ModalBody>
          <RoomPasswordForm />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default RoomPasswordModal;
